export default __webpack_public_path__ + "static/partners02-ceecf0e299e76d904210b0e959dd2dcf.svg";